import { render, staticRenderFns } from "./PurchOrderReapBody.vue?vue&type=template&id=49ac82d4&scoped=true&"
import script from "./PurchOrderReapBody.vue?vue&type=script&lang=js&"
export * from "./PurchOrderReapBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ac82d4",
  null
  
)

export default component.exports